import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './modules/auth/logout/logout.component';
import { Page404Component } from './modules/auth/page-404/page-404.component';
import { MainLayoutComponent } from './modules/layout/main-layout/main-layout.component';
import { AuthGuard } from './modules/core/guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'accounts',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/accounts/accounts.module').then((m) => m.AccountsModule),
      },
      {
        path: 'account-details/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/account-info/account-info.module').then((m) => m.AccountInfoModule),
      },
      {
        path: 'scheduling',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/scheduling/scheduling.module').then((m) => m.SchedulingModule),
      },
      {
        path: 'task/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/task-info/task-info.module').then((m) => m.TaskInfoModule),
      },
      {
        path: 'roles-permissions',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/roles-and-permissions/roles-and-permissions.module').then((m) => m.RolesAndPermissionsModule),
      },
      {
        path: 'subscription',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/subscription/subscription.module').then((m) => m.SubscriptionModule),
      },
      {
        path: 'statutory-compliance',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/statutory-compliance/statutory-compliance.module').then((m) => m.StatutoryComplianceModule),
      },
      {
        path: 'support',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/pages/support/support.module').then((m) => m.SupportModule),
      },
      {
        path:'settings',
        canActivate:[AuthGuard],
        loadChildren: () =>import('./modules/settings/settings.module').then((m)=>m.SettingsModule)
      },
      {
        path:'holiday-calender',
        canActivate:[AuthGuard],
        loadChildren: () => import('./modules/pages/holiday-calender/holiday-calender.module').then((m)=>m.HolidayCalenderModule)
      },
      {
        path:'setup',
        canActivate:[AuthGuard],
        loadChildren: () => import('./modules/pages/business-setup/business-setup.module').then((m)=>m.BusinessSetupModule)
      }
    ]
  },
  { path: "logout", component: LogoutComponent },
  { path: "**", component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
